module.exports = __webpack_public_path__ + "img/close-white-18dp.2ed6ccfe.svg";